import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useDocumentOfSalesStore } from "../../hooks/useDocumentOfSalesStore";

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'status', label: 'Estado', align:'center', format:(row) => row.status == 1 ? 'Activado' : 'Desactivado' },
    { type: 'detail', field: 'detail', label: 'Acciones', align:'center' },
];

export const SalesDocumentView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionDocumentSale, getDocumentOfSales, getDocumentOfSalesByCompany } = useDocumentOfSalesStore();

    const [loading, setLoading] = useState(false);
    const [salesDocument, setSalesDocument] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getDocumentsApi()
    },[])

    const getDocumentsApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getDocumentOfSales(search);
            if(!response){
                setSalesDocument([]);
                setLoading(false);
                return false;
            }else{
                setSalesDocument(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionDocumentSale('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionDocumentSale('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionDocumentSale('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionDocumentSale('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onSwitch = (rowSelected) => {

    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getDocumentsApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Documentos de venta'}
                    columns={columns} 
                    loading={loading}
                    rows={salesDocument || []}
                    onRowClick={() => {}}
                    hasOptions
                    onSwitch={onSwitch}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {/* {
                showModal && (
                    <UserModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        userSelected = {rowSelected}
                        listUser = {getUsersApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            } */}
        </>
    )
}